import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d17fb68a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "spinner-border ml-2",
  role: "status"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.elementType), _mergeProps(_ctx.elementProps, {
    class: _ctx.buttonClasses,
    "aria-disabled": _ctx.isDisabled ? true : undefined,
    "aria-busy": _ctx.loading ? true : undefined,
    tabindex: _ctx.isDisabled ? -1 : undefined,
    title: _ctx.tooltip || undefined,
    "data-toggle": _ctx.tooltip ? 'tooltip' : undefined,
    onClick: _ctx.handleClick
  }), {
    default: _withCtx(() => [
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass('fas ' + _ctx.icon)
          }, null, 2))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.name) + " ", 1),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16, ["class", "aria-disabled", "aria-busy", "tabindex", "title", "data-toggle", "onClick"]))
}